// Global Imports
import * as React from "react";
// Controls
import { IconIndicator } from "./IconIndicator";
// Style
import { useTheme } from "@fluentui/react";
import { attachSmallIconProps } from "../../../icons/icons.styles";
import { getBaseIndicatorStyles } from "./Indicators.styles";
// Utilities
import * as StringHelper from "@fluentui/utilities";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Attachment Indicator component that renders an icon with the number of attachments
 */ export const AttachmentIndicator = (props)=>{
    const numAttachments = Math.max(props.numberOfAttachments, 0);
    const ariaBaseString = numAttachments === 1 ? Strings.AttachmentIndicator_AttachmentsIndicatorAriaLabelSingular : Strings.AttachmentIndicator_AttachmentsIndicatorAriaLabelPlural;
    const ariaLabel = StringHelper.format(ariaBaseString, numAttachments);
    const theme = useTheme();
    const styles = getBaseIndicatorStyles(theme);
    return /*#__PURE__*/ React.createElement("div", {
        className: "attachment indicator",
        title: ariaLabel
    }, /*#__PURE__*/ React.createElement(IconIndicator, {
        ...props,
        ariaLabel: ariaLabel,
        label: numAttachments.toString(),
        iconProps: attachSmallIconProps,
        styles: styles
    }));
};
